import '@/components/ui/SectionDividerWithLines/SectionDividerWithLines.css';

export interface ContextMenuSectionHeaderProps {
  label: string;
}

/** Заголовок секции внутри `ul.context-menu__list` (линии + подпись). */
export function ContextMenuSectionHeader({ label }: ContextMenuSectionHeaderProps) {
  return (
    <li role="presentation" className="context-menu__list-item">
      <div
        className="section-divider-with-lines section-divider-with-lines_full-bleed section-divider-with-lines_context-menu"
        role="separator"
        aria-label={label}
      >
        <span className="section-divider-with-lines__label">{label}</span>
      </div>
    </li>
  );
}
